import React from 'react'
import { Row, Col, Form, Input } from 'antd'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { userRegister } from '../redux/actions/userActions'


function Register() {
  const dispatch = useDispatch()

  function onFinish(values) {
    dispatch(userRegister(values))
    console.log(values)
  }
  return (
    <div className='login'>
      <Row gutter={16} className='d-flex align-items-center'>
        {/* Image side - hide on small screens */}
        <Col lg={16} md={12} sm={0} xs={0} style={{ position: 'relative' }}>
          <img
            src='https://images.pexels.com/photos/261985/pexels-photo-261985.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
            alt='a nice car'
            className='login-img'
          />
          <h1 className='login-logo'>LuxuryLifeLimo</h1>
        </Col>

        {/* Form side - full width on mobile */}
        <Col lg={8} md={12} sm={24} xs={24} className='text-left p-5'>
          <Form layout='vertical' className='login-form p-5' onFinish={onFinish}>
            <h1>Register</h1>
            <hr />
            <Form.Item name='username' label='Username' rules={[{ required: true }]}>
              <Input />
            </Form.Item>

            <Form.Item name='email' label='Email' rules={[{ required: true, type: 'email' }]}>
              <Input />
            </Form.Item>

            <Form.Item name='password' label='Password' rules={[{ required: true }]}>
              <Input />
            </Form.Item>

            <Form.Item name='cpassword' label='Confirm Password' rules={[{ required: true }]}>
              <Input />
            </Form.Item>


            <button className='btn1 mt-2 mb-3'>Register</button>
            <br />
            <Link to='/login'>Click Here to Login</Link>
          </Form>
        </Col>
      </Row>

    </div>
  )
}

export default Register